module.exports = "/assets/883806c589638827e194161a76c087a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/XE.png
// module id = 3111
// module chunks = 0